import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { altaUsuario, passwordDTO } from '../entidades/entidades.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { PasswordValidatorService } from '../servicios/password-validator.service';
//import {SharedModule} from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-dialogo-actualizar-password',
    templateUrl: './dialogo-actualizar-password.component.html',
    styleUrls: ['./dialogo-actualizar-password.component.css'],
    standalone: true,
    imports: [CommonModule,FormsModule, MatIconModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
})
export class DialogoActualizarPasswordComponent implements OnInit {
  durationInSeconds = 4;
  showPasswordPw = false;
  showPasswordRePw = false;
  userName;
  nuevaPassword = '';
  nuevaRePassword;
  showSpinner = false;

  constructor(private _snackBar: MatSnackBar, public dialogRef: MatDialogRef<DialogoActualizarPasswordComponent>,
    private PerfilesUsuarioService: PerfilesUsuarioService,
    public passValidator: PasswordValidatorService) { }

  ngOnInit(): void {
    this.userName = localStorage.getItem('username');
  }

  @ViewChild('changePassword') form: any

  ngAfterViewInit() {
    this.form.control.valueChanges
      .subscribe(({ contrasenia, REcontrasenia }: altaUsuario) => {
        this.passValidator.checkPassword(contrasenia, REcontrasenia)
      });
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getInputTypePw() {
    if (this.showPasswordPw) {
      return 'text';
    }
    return 'password';
  }

  getIconPw() {
    if (this.showPasswordPw) {
      return 'visibility';
    }
    return 'visibility_off';
  }

  getInputTypeRePw() {
    if (this.showPasswordRePw) {
      return 'text';
    }
    return 'password';
  }

  getIconRePw() {
    if (this.showPasswordRePw) {
      return 'visibility';
    }
    return 'visibility_off';
  }

  toggleShowPassword() {
    this.showPasswordPw = !this.showPasswordPw;
  }

  toggleShowRPassword() {
    this.showPasswordRePw = !this.showPasswordRePw;
  }

  actualizarPassword() {
    let actualizarPassword: passwordDTO;
    this.showSpinner = true;

    actualizarPassword = {
      username: this.userName,
      password: this.nuevaPassword
    }

    this.PerfilesUsuarioService.changePassword(actualizarPassword).subscribe(data => {
      if (data["status"] == 200) {
        this.openSnackBar('La contraseña se ha actualizado correctamente');
      } else {
        this.openSnackBar('Ha ocurrido un error al actualizar la contraseña');
      }
      this.showSpinner = false;
      this.closeDialog();
    })

    this.userName = '';
    this.nuevaPassword = '';
  }

}


